/**
 * Converia.Core.module
 *
 * Converia.SiteStructure.RowContent
 */

Converia.Core.module('Converia.SiteStructure.RowContent', function () {
    /**
     * RowContent
     * 
     * @param splitOptions
     * @constructor
     */
    var RowContent = function (splitOptions) {
        this.columns = [];
        this.columnSplit = '';
        this.splitOptions = splitOptions;
    };

    /**
     * RowContent.prototype.getColumns
     * 
     * @returns {Array}
     */
    RowContent.prototype.getColumns = function () {
        return this.columns;
    };

    /**
     * RowContent.prototype.addColumn
     */
    RowContent.prototype.addColumn = function () {
        this.columns.push(
            new Converia.SiteStructure.Column([])
        );

        this.columnSplit = loadSplitOptions(this.getSplitOptionsForCurrentColumnCount());
    };

    /**
     * RowContent.prototype.removeLastColumn
     */
    RowContent.prototype.removeLastColumn = function () {
        this.columns.splice((this.columns.length) - 1, 1);
        this.columnSplit = loadSplitOptions(this.getSplitOptionsForCurrentColumnCount());
    };

    /**
     * RowContent.prototype.getColumnSplit
     * 
     * @returns {string}
     */
    RowContent.prototype.getColumnSplit = function () {
        return this.columnSplit;
    };

    /**
     * RowContent.prototype.setColumnSplit
     * 
     * @param split
     */
    RowContent.prototype.setColumnSplit = function (split) {
        this.columnSplit = loadSplitOptions(this.getSplitOptionsForCurrentColumnCount(), split);
    };

    /**
     * RowContent.prototype.initDefault
     * 
     */
    RowContent.prototype.initDefault = function () {
        this.columns.push(new Converia.SiteStructure.Column([]));
        this.columns.push(new Converia.SiteStructure.Column([]));
        this.columnSplit = loadSplitOptions(this.getSplitOptionsForCurrentColumnCount());
    };

    /**
     * RowContent.prototype.loadFromJson
     * 
     * @param data
     */
    RowContent.prototype.loadFromJson = function (data) {
        for (var columnIndex = 0, columnListLength = data.columns.length; columnIndex < columnListLength; columnIndex++) {
            var articleJson = data.columns[columnIndex];
            var articles = [];

            for (var articleIndex = 0, articleListLength = articleJson.length; articleIndex < articleListLength; articleIndex++) {
                articles.push(
                    new Converia.SiteStructure.Article(
                        articleJson[articleIndex]
                    )
                );
            }

            this.columns.push(
                new Converia.SiteStructure.Column(
                    articles
                )
            );
        }

        this.columnSplit = loadSplitOptions(this.getSplitOptionsForCurrentColumnCount(), data.columnSplit);
    };

    /**
     * RowContent.prototype.getAllSplitOptions
     * 
     * @returns {Array}
     */
    RowContent.prototype.getAllSplitOptions = function () {
        var options = [];
        for (var i = 1; i < 5; i++) {
            options = options.concat(this.splitOptions[i]);
        }
        return options;
    };

    /**
     * RowContent.prototype.getSplitOptionsForCurrentColumnCount
     * 
     * @returns {Array}
     */
    RowContent.prototype.getSplitOptionsForCurrentColumnCount = function () {
        var columnCount = this.columns.length;

        if (typeof this.splitOptions[columnCount] === 'undefined') {
            throw new Error('Column split not found for column count: '.columnCount);
        }

        var splitOptionsForCurrentColumnCount = this.splitOptions[columnCount];

        return splitOptionsForCurrentColumnCount;
    };

    /**
     * RowContent.prototype.getColumnCssClassFor
     * 
     * @param columnIndex
     * @returns {string}
     */
    RowContent.prototype.getColumnCssClassFor = function (columnIndex) {

        switch (this.columnSplit) {
            case '25_25_25_25':
                return 'column-cms-25';
                break;
            case '33_33_33':
                return 'column-cms-33';
                break;
            case '33_66':
                if (columnIndex === 0) {
                    return 'column-cms-33';
                }

                return 'column-cms-66';
                break;
            case '50_50':
                return 'column-cms-50';
                break;
            case '66_33':
                if (columnIndex === 0) {
                    return 'column-cms-66';
                }

                return 'column-cms-33';
                break;
            case '100':
            default:
                return 'column-cms-100';
        }
    };

    /**
     * RowContent.prototype.getColumnCountForSplitValue
     * 
     * @param splitValue
     * @returns {number}
     */
    RowContent.prototype.getColumnCountForSplitValue = function (splitValue) {
        var count = (splitValue.match(/_/g) || []).length;
        return count + 1;//column count is one large as underscores in value
    };

    /**
     * RowContent.prototype.toJson
     * 
     * @returns {{columns: Array, columnSplit: *}}
     */
    RowContent.prototype.toJson = function () {
        var data = {
            columns: [],
            columnSplit: this.columnSplit
        };

        for (var i = 0, len = this.columns.length; i < len; i++) {
            var currentColumn = this.columns[i];
            data.columns.push(
                currentColumn.toJson()
            );
        }

        return data;
    };

    /**
     * loadSplitOptions
     * 
     * @param options
     * @param splitOption
     * @returns {string}
     */
    var loadSplitOptions = function (options, splitOption) {
        if (splitOption && (options.indexOf(splitOption) > -1)) {
            return splitOption;
        }

        return options[0];
    };

    return RowContent;
});